import { Helmet } from "react-helmet";
import NewHead from "../../landing/NewHead";
import "./healthcare.css";
import ServiceFooter from "../../ServiceFooter";
import { useRef } from "react";
import { useEffect } from "react";

import { Navigation, A11y } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/navigation";
import { useState } from "react";

import Marquee from "react-marquee-slider";

const Healthcare = () => {
  const cardRefs = useRef([]);
  const smallImgOneRef = useRef(null);
  const smallImgTwoRef = useRef(null);
  const smallImgThreeRef = useRef(null); // New reference for .hl-hero-sm-three

  useEffect(() => {
    const handleScroll = () => {
      const viewportHeight = window.innerHeight;

      // Handle left and right images movement
      cardRefs.current.forEach((card, index) => {
        if (!card) return;

        const rect = card.getBoundingClientRect();
        const scrollRatio = Math.min(
          1,
          Math.max(0, 1 - rect.top / viewportHeight)
        );
        const easingFactor = Math.pow(scrollRatio, 2); // Smooth easing effect

        // Initial positions (translateX: 50px)
        const initialTransforms = [
          { x: 70, rotateZ: 0 }, // Left image starts slightly right
          { x: -70, rotateZ: 0 }, // Right image starts slightly left
        ];

        // Final positions (Move outward + slight rotation)
        const finalTransforms = [
          { x: -100, rotateZ: -10 }, // Left image moves left & rotates counterclockwise
          { x: 100, rotateZ: 10 }, // Right image moves right & rotates clockwise
        ];

        const targetX =
          initialTransforms[index].x +
          (finalTransforms[index].x - initialTransforms[index].x) *
            easingFactor;
        const targetRotation =
          initialTransforms[index].rotateZ +
          (finalTransforms[index].rotateZ - initialTransforms[index].rotateZ) *
            easingFactor;

        card.style.transform = `translate3d(${targetX}px, 160px, 0) rotateZ(${targetRotation}deg)`;
      });

      // Handle .hl-hero-sm-one movement (left: 69% -> 52%)
      if (smallImgOneRef.current) {
        const rect = smallImgOneRef.current.getBoundingClientRect();
        const scrollRatio = Math.min(
          1,
          Math.max(0, 1 - rect.top / viewportHeight)
        );
        const easingFactor = Math.pow(scrollRatio, 2); // Smooth easing effect

        const initialLeft = 60; // Initial left position (69%)
        const finalLeft = 46; // Final left position (52%)

        const targetLeft =
          initialLeft + (finalLeft - initialLeft) * easingFactor;
        smallImgOneRef.current.style.left = `${targetLeft}%`;
      }

      // Handle .hl-hero-sm-two movement (top: 24% -> 36%, left: 30% -> 36%)
      if (smallImgTwoRef.current) {
        const rect = smallImgTwoRef.current.getBoundingClientRect();
        const scrollRatio = Math.min(
          1,
          Math.max(0, 1 - rect.top / viewportHeight)
        );
        const easingFactor = Math.pow(scrollRatio, 2); // Smooth easing effect

        const initialTop = 18; // Initial top position (24%)
        const finalTop = 36; // Final top position (36%)

        const initialLeft = 30; // Initial left position (30%)
        const finalLeft = 36; // Final left position (36%)

        const targetTop = initialTop + (finalTop - initialTop) * easingFactor;
        const targetLeft =
          initialLeft + (finalLeft - initialLeft) * easingFactor;

        smallImgTwoRef.current.style.top = `${targetTop}%`;
        smallImgTwoRef.current.style.left = `${targetLeft}%`;
      }

      // Handle .hl-hero-sm-three movement (left: 11% -> 50%)
      if (smallImgThreeRef.current) {
        const rect = smallImgThreeRef.current.getBoundingClientRect();
        const scrollRatio = Math.min(
          1,
          Math.max(0, 1 - rect.top / viewportHeight)
        );
        const easingFactor = Math.pow(scrollRatio, 2); // Smooth easing effect

        const initialLeft = 14; // Initial left position (11%)
        const finalLeft = 30; // Final left position (50%)

        const targetLeft =
          initialLeft + (finalLeft - initialLeft) * easingFactor;
        smallImgThreeRef.current.style.left = `${targetLeft}%`;
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // services
  const [isPrevServiceDisabled, setIsPrevServiceDisabled] = useState(true);
  const [isNextServiceDisabled, setIsNextServiceDisabled] = useState(false);

  const handleServiceChange = (ServiceSwiper) => {
    setIsPrevServiceDisabled(ServiceSwiper.isBeginning);
    setIsNextServiceDisabled(ServiceSwiper.isEnd);
  };

  // process
  const [isPrevProcessDisabled, setIsPrevProcessDisabled] = useState(true);
  const [isNextProcessDisabled, setIsNextProcessDisabled] = useState(false);

  const handleProcessChange = (ProcessSwiper) => {
    setIsPrevProcessDisabled(ProcessSwiper.isBeginning);
    setIsNextProcessDisabled(ProcessSwiper.isEnd);
  };

  // why choose
  const [isPrevChooseDisabled, setIsPrevChooseDisabled] = useState(true);
  const [isNextChooseDisabled, setIsNextChooseDisabled] = useState(false);

  const handleChooseChange = (ChooseSwiper) => {
    setIsPrevChooseDisabled(ChooseSwiper.isBeginning);
    setIsNextChooseDisabled(ChooseSwiper.isEnd);
  };

  const [velocity, setVelocity] = useState(60); // Default for larger screens

  useEffect(() => {
    const updateVelocity = () => {
      if (window.innerWidth <= 575) {
        setVelocity(16); // Very slow for small mobile
      } else if (window.innerWidth <= 768) {
        setVelocity(30); // Slower for mobile
      } else if (window.innerWidth <= 1600) {
        setVelocity(40); // Moderate speed for tablets
      } else {
        setVelocity(60); // Default speed for larger screens
      }
    };

    updateVelocity();
    window.addEventListener("resize", updateVelocity);
    return () => window.removeEventListener("resize", updateVelocity);
  }, []);

  const [techActiveTab, setTechActiveTab] = useState("ai");

  const handleTabClick = (tabId) => {
    setTechActiveTab(tabId);
  };

  return (
    <>
      <NewHead />

      <Helmet>
        <title> Healthcare app development company</title>

        <meta name="title" content=" Healthcare app development company " />
        <meta
          name="description"
          content="As a leading healthcare app development company, we offer end-to-end mobile and web app development services that cater to hospitals, clinics, pharmacies, insurance companies, and telemedicine providers."
        />

        <meta
          property="og:title"
          content=" Healthcare app development company"
        />
        <meta property="og:site_name" content="Beleaf Technologies" />

        <link
          rel="canonical"
          href="https://www.beleaftechnologies.com/healthcare-app-development-company"
        />
      </Helmet>

      <main className="hl-main">
        {/* hero */}
        <article className="hl-hero hl-mb-100">
          <h1 className="hl-hero-title">
            <span className="hl-span">Healthcare App </span>Development Company
          </h1>
          <button
            data-toggle="modal"
            data-target="#myModal"
            className="hl-hero-btn"
          >
            Get Started Now
          </button>

          <div className="hl-hero-img">
            <img
              src={require("../../../image/healthcare/hero-sm-two.webp")}
              alt="Healthcare app development company"
              loading="lazy"
              className="hl-hero-sm-two"
              ref={smallImgTwoRef}
            />
            <img
              src={require("../../../image/healthcare/hero-sm-three.webp")}
              alt="Healthcare app development company"
              loading="lazy"
              className="hl-hero-sm-three"
              ref={smallImgThreeRef}
            />

            <img
              src={require("../../../image/healthcare/hero-img-lft.webp")}
              alt="Healthcare app development company"
              loading="lazy"
              className="hl-hero-img-lft"
              ref={(el) => (cardRefs.current[0] = el)}
            />

            <img
              src={require("../../../image/healthcare/hero-img-center.webp")}
              alt="Healthcare app development company"
              loading="lazy"
              className="hl-hero-img-center"
            />

            <img
              src={require("../../../image/healthcare/hero-img-rgt.webp")}
              alt="Healthcare app development company"
              loading="lazy"
              className="hl-hero-img-rgt"
              ref={(el) => (cardRefs.current[1] = el)}
            />

            <img
              src={require("../../../image/healthcare/hero-sm-one.webp")}
              alt="Healthcare app development company"
              loading="lazy"
              className="hl-hero-sm-one"
              ref={smallImgOneRef}
            />

            <img
              src={require("../../../image/healthcare/hero-btm.webp")}
              alt="Healthcare app development company"
              loading="lazy"
              className="hl-hero-btm"
            />
          </div>
          <div className="hl-hero-mob-img">
            <img
              src={require("../../../image/healthcare/hero-mob.webp")}
              alt="Healthcare app development company"
              loading="lazy"
            />
          </div>
        </article>

        {/* about */}
        <article className="hl-about primary__landing-content-container ">
          <div className="row mx-0 align-items-center hl-about-row">
            <div className="col-lg-6">
              <h3 className="hl-subtitle">
                What is <span className="hl-span"> Healthcare App</span>{" "}
                development?
              </h3>
              <p className="hl-subcontent">
                Healthcare app development refers to the process of designing,
                building, and maintaining applications specifically tailored for
                the healthcare industry. These apps are created to improve
                patient care, enhance healthcare services, and streamline
                healthcare operations through technology. Healthcare apps can
                serve a wide range of purposes, including helping patients
                manage their health, providing remote consultations etc.
              </p>
              <button
                data-toggle="modal"
                data-target="#myModal"
                className="primary-landing-main-btn re-hero-btn mt-4"
              >
                <div className="re-btn-txt">Get Free Demo</div>
                <span className="mx-2 right-arr">
                  <i className="fa-solid fa-arrow-right"></i>
                </span>
              </button>
            </div>
            <div className="col-lg-6 text-center">
              <img
                src={require("../../../image/healthcare/about.webp")}
                alt="Healthcare app development company"
                loading="lazy"
              />
            </div>
          </div>
        </article>

        {/* why */}
        <article className="hl-why primary__landing-content-container hl-mb-100">
          <div className="row hl-why-row mx-0 ">
            <div className="col-lg-6">
              <img
                src={require("../../../image/healthcare/why.webp")}
                alt="Healthcare app development company"
                loading="lazy"
                className="hl-why-img"
              />
            </div>
            <div className="col-lg-6 hl-why-col">
              <h3 className="hl-subtitle text-white hl-why-title">
                Why is Healthcare App Development Important?
              </h3>
              <p className="hl-subcontent hl-why-content">
                The healthcare industry is undergoing a digital transformation.
                With rising patient expectations, the need for innovative
                solutions, and the demand for better healthcare services,
                healthcare app development has become an essential part of the
                modern healthcare ecosystem.
              </p>
              <button
                data-toggle="modal"
                data-target="#myModal"
                className="primary-landing-hero-btn re-hero-btn"
              >
                <div className="re-btn-txt"> Get Consulation</div>
                <span className="mx-2 right-arr">
                  <i className="fa-solid fa-arrow-right"></i>
                </span>
              </button>
            </div>
          </div>
        </article>

        {/* key features */}
        <article className="hl-key primary__landing-content-container hl-mb-100">
          <h3 className="hl-subtitle hl-key-title">
            Key Features of a{" "}
            <span className="hl-span">Successful Healthcare</span> App
            Development
          </h3>
          <p className="hl-subcontent hl-key-content">
            When developing a healthcare application, certain features are
            crucial for ensuring its success. Here are some of the most
            important features your app should include
          </p>

          <div className="row mx-0 hl-key-row g-4">
            <div className="col-lg-4 col-md-6">
              <div className="hl-key-card">
                <img
                  src={require("../../../image/healthcare/key-img-one.webp")}
                  alt="Healthcare app development company"
                  loading="lazy"
                />
                <h5>User-Friendly Interface</h5>
                <p>
                  A simple and intuitive design is crucial for both patients and
                  healthcare providers.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="hl-key-card">
                <img
                  src={require("../../../image/healthcare/key-img-two.webp")}
                  alt="Healthcare app development company"
                  loading="lazy"
                />
                <h5>Appointment Booking & Scheduling</h5>
                <p>
                  Allow patients to easily schedule consultations, treatments,
                  or checkups.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="hl-key-card">
                <img
                  src={require("../../../image/healthcare/key-img-three.webp")}
                  alt="Healthcare app development company"
                  loading="lazy"
                />
                <h5>Telemedicine Capabilities</h5>
                <p>
                  Provide patients with virtual consultations with healthcare
                  professionals through video calls.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="hl-key-card">
                <img
                  src={require("../../../image/healthcare/key-img-four.webp")}
                  alt="Healthcare app development company"
                  loading="lazy"
                />
                <h5>Medication Management</h5>
                <p>
                  Enable patients to track their prescriptions, set medication
                  reminders, and receive alerts.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="hl-key-card">
                <img
                  src={require("../../../image/healthcare/key-img-five.webp")}
                  alt="Healthcare app development company"
                  loading="lazy"
                />
                <h5>Real-Time Health Monitoring</h5>
                <p>
                  Integrate wearables or other devices to monitor vital signs,
                  such as heart rate, blood pressure, and glucose levels.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="hl-key-card">
                <img
                  src={require("../../../image/healthcare/key-img-six.webp")}
                  alt="Healthcare app development company"
                  loading="lazy"
                />
                <h5>Patient Records Management</h5>
                <p>
                  Securely store and access patient medical histories,
                  diagnoses, and test results.
                </p>
              </div>
            </div>
          </div>
        </article>

        <div className="hl-dark-bg hl-mb-100">
          {/* services */}
          <article className="hl-services primary__landing-content-container hl-mb-100">
            <h3 className="hl-subtitle hl-service-title">
              Healthcare App Development{" "}
              <span className="hl-span">Services We Offer</span>
            </h3>
            <p className="hl-subcontent hl-service-content">
              As a reputed healthcare app development company, we offer a wide
              range of services tailored to the needs of healthcare businesses.
            </p>

            <div>
              <Swiper
                className="fd-step-swiper"
                spaceBetween={30}
                slidesPerView={3}
                modules={[Navigation, A11y]}
                navigation={{
                  prevEl: ".fd-st-prev-arr",
                  nextEl: ".fd-st-next-arr",
                }}
                breakpoints={{
                  320: {
                    slidesPerView: 1,
                    spaceBetween: 10,
                  },
                  480: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                  },
                  768: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                  },
                  1025: {
                    slidesPerView: 3,
                    spaceBetween: 40,
                  },
                  1200: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                  },
                }}
                onSlideChange={handleServiceChange}
                onReachBeginning={() => setIsPrevServiceDisabled(true)}
                onReachEnd={() => setIsNextServiceDisabled(true)}
                onFromEdge={() => {
                  setIsPrevServiceDisabled(false);
                  setIsNextServiceDisabled(false);
                }}
                speed={500}
              >
                <SwiperSlide>
                  <div className="hl-service-card-outer">
                    <div className="hl-service-inner">
                      <div className="hl-service-card">
                        <h5>Telemedicine App Development</h5>
                        <img
                          src={require("../../../image/healthcare/service-img-one.webp")}
                          alt="Healthcare app development company"
                          loading="lazy"
                          className="hl-service-img"
                        />
                      </div>
                      <div className="hl-service-card-back">
                        <h4>Telemedicine App Development</h4>
                        <p>
                          Telemedicine apps enable remote consultations,
                          reducing the need for in-person visits. Key features
                          include
                        </p>
                        <ul className="hl-service-list">
                          <li>Video/audio consultations</li>
                          <li>Appointment scheduling</li>
                          <li> Digital prescriptions</li>
                          <li>EHR integration</li>
                          <li>Payment gateway integration</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="hl-service-card-outer">
                    <div className="hl-service-inner">
                      <div className="hl-service-card">
                        <h5>EHR & EMR Development</h5>
                        <img
                          src={require("../../../image/healthcare/service-img-two.webp")}
                          alt="Healthcare app development company"
                          loading="lazy"
                          className="hl-service-img"
                        />
                      </div>
                      <div className="hl-service-card-back">
                        <h4>EHR & EMR Development</h4>
                        <p>Our EHR and EMR solutions provide</p>
                        <ul className="hl-service-list">
                          <li>Secure storage of patient data</li>
                          <li>Easy access for doctors and patients</li>
                          <li> AI based data analytics</li>
                          <li>
                            Cloud-based solutions for remote accessibility
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="hl-service-card-outer">
                    <div className="hl-service-inner">
                      <div className="hl-service-card">
                        <h5>AI Based Healthcare Solutions</h5>
                        <img
                          src={require("../../../image/healthcare/service-img-three.webp")}
                          alt="Healthcare app development company"
                          loading="lazy"
                          className="hl-service-img"
                        />
                      </div>
                      <div className="hl-service-card-back">
                        <h4>AI Based Healthcare Solutions</h4>
                        <p>
                          AI in healthcare enhances diagnostics, treatment, and
                          patient management. Our AI-powered solutions include
                        </p>
                        <ul className="hl-service-list">
                          <li>
                            AI-driven diagnostics and predictive analytics
                          </li>
                          <li>Chatbots for instant medical assistance</li>
                          <li> Virtual health assistants</li>
                          <li>Automated patient engagement</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="hl-service-card-outer">
                    <div className="hl-service-inner">
                      <div className="hl-service-card">
                        <h5>Blockchain Based Healthcare Solutions</h5>
                        <img
                          src={require("../../../image/healthcare/service-img-four.webp")}
                          alt="Healthcare app development company"
                          loading="lazy"
                          className="hl-service-img"
                        />
                      </div>
                      <div className="hl-service-card-back">
                        <h4>Blockchain Based Healthcare Solutions</h4>
                        <p>
                          Blockchain enhances security, transparency, and
                          efficiency in healthcare transactions. Our solutions
                          include
                        </p>
                        <ul className="hl-service-list">
                          <li>Secure patient data management</li>
                          <li>Smart contracts for healthcare agreements</li>
                          <li> Decentralized health records</li>
                          <li>Fraud prevention in insurance claims</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="hl-service-card-outer">
                    <div className="hl-service-inner">
                      <div className="hl-service-card">
                        <h5>On Demand Doctor Appointment Apps</h5>
                        <img
                          src={require("../../../image/healthcare/service-img-five.webp")}
                          alt="Healthcare app development company"
                          loading="lazy"
                          className="hl-service-img"
                        />
                      </div>
                      <div className="hl-service-card-back">
                        <h4>On Demand Doctor Appointment Apps</h4>
                        <p>
                          We develop robust on-demand healthcare platforms for
                          easy doctor booking. Key features
                        </p>
                        <ul className="hl-service-list">
                          <li>Real-time appointment booking</li>
                          <li>Doctor profile browsing</li>
                          <li> Location-based searches</li>
                          <li>E-prescriptions</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="hl-service-card-outer">
                    <div className="hl-service-inner">
                      <div className="hl-service-card">
                        <h5>Pharmacy Delivery App Development</h5>
                        <img
                          src={require("../../../image/healthcare/service-img-six.webp")}
                          alt="Healthcare app development company"
                          loading="lazy"
                          className="hl-service-img"
                        />
                      </div>
                      <div className="hl-service-card-back">
                        <h4>Pharmacy Delivery App Development</h4>
                        <p>
                          Online pharmacy apps streamline medication delivery.
                          Features include
                        </p>
                        <ul className="hl-service-list">
                          <li>Prescription uploads and verification</li>
                          <li>Drug price comparison</li>
                          <li> Order tracking and home delivery</li>
                          <li>Automated refill reminders</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="hl-service-card-outer">
                    <div className="hl-service-inner">
                      <div className="hl-service-card">
                        <h5>Healthcare Chatbot Development</h5>
                        <img
                          src={require("../../../image/healthcare/service-img-seven.webp")}
                          alt="Healthcare app development company"
                          loading="lazy"
                          className="hl-service-img"
                        />
                      </div>
                      <div className="hl-service-card-back">
                        <h4>Healthcare Chatbot Development</h4>
                        <p>
                          Chatbots enhance patient engagement by providing
                          instant medical assistance. Our chatbots include
                        </p>
                        <ul className="hl-service-list">
                          <li>AI-driven symptom checkers</li>
                          <li>Appointment booking assistance</li>
                          <li> Medication reminders</li>
                          <li>24/7 patient support</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              </Swiper>

              <div className="fd-step-btn-wrap">
                <button
                  className={`fd-st-prev-arr ${
                    isPrevServiceDisabled ? "disabled" : ""
                  }`}
                  style={{
                    color: isPrevServiceDisabled ? "#ffffff80" : "#000000",
                    cursor: isPrevServiceDisabled ? "not-allowed" : "pointer",
                    background: isPrevServiceDisabled ? "#3E3E40" : "#ffffff",
                  }}
                >
                  <i className="fa-solid fa-chevron-left"></i>
                </button>
                <button
                  className={`fd-st-next-arr ${
                    isNextServiceDisabled ? "disabled" : ""
                  }`}
                  style={{
                    color: isNextServiceDisabled ? "#ffffff80" : "#000000",
                    cursor: isNextServiceDisabled ? "not-allowed" : "pointer",
                    background: isNextServiceDisabled ? "#3E3E40" : "#ffffff",
                  }}
                >
                  <i className="fa-solid fa-chevron-right"></i>
                </button>
              </div>
            </div>
          </article>

          {/* technologies */}
          <article className="hl-tech primary__landing__container hl-mb-100">
            <div className="row align-items-center">
              <div className="col-lg-7">
                <h3 className="hl-subtitle text-white hl-tech-title">
                  <span className="hl-span">Technologies We Use </span>
                  for Healthcare App Development
                </h3>
              </div>
              <div className="col-lg-5">
                <p className="hl-subcontent hl-tech-content">
                  Our healthcare app development company leverages cutting-edge
                  technologies to build high-performing healthcare applications
                </p>
              </div>
            </div>

            <div className="row mx-0 hl-tech-tabs-row">
              <div className="col-xl-4 col-lg-5 col-sm-6">
                <ul className="hl-tech-left-outer">
                  <li
                    className={`hl-tech-left-list ${
                      techActiveTab === "ai" ? "active" : ""
                    }`}
                    onClick={() => handleTabClick("ai")}
                  >
                    Artificial Intelligence (AI){" "}
                    <span
                      className={`hl-tech-arr ${
                        techActiveTab === "ai" ? "show" : ""
                      }`}
                    >
                      <i className="fa-solid fa-arrow-right"></i>
                    </span>
                  </li>
                  <li
                    className={`hl-tech-left-list ${
                      techActiveTab === "blockchain" ? "active" : ""
                    }`}
                    onClick={() => handleTabClick("blockchain")}
                  >
                    Blockchain{" "}
                    <span
                      className={`hl-tech-arr ${
                        techActiveTab === "blockchain" ? "show" : ""
                      }`}
                    >
                      <i className="fa-solid fa-arrow-right"></i>
                    </span>
                  </li>
                  <li
                    className={`hl-tech-left-list ${
                      techActiveTab === "cloud" ? "active" : ""
                    }`}
                    onClick={() => handleTabClick("cloud")}
                  >
                    Cloud Computing{" "}
                    <span
                      className={`hl-tech-arr ${
                        techActiveTab === "cloud" ? "show" : ""
                      }`}
                    >
                      <i className="fa-solid fa-arrow-right"></i>
                    </span>
                  </li>
                  <li
                    className={`hl-tech-left-list ${
                      techActiveTab === "bigdata" ? "active" : ""
                    }`}
                    onClick={() => handleTabClick("bigdata")}
                  >
                    Big Data Analytics{" "}
                    <span
                      className={`hl-tech-arr ${
                        techActiveTab === "bigdata" ? "show" : ""
                      }`}
                    >
                      <i className="fa-solid fa-arrow-right"></i>
                    </span>
                  </li>
                  <li
                    className={`hl-tech-left-list ${
                      techActiveTab === "ar" ? "active" : ""
                    }`}
                    onClick={() => handleTabClick("ar")}
                  >
                    Augmented Reality (AR) & (VR){" "}
                    <span
                      className={`hl-tech-arr ${
                        techActiveTab === "ar" ? "show" : ""
                      }`}
                    >
                      <i className="fa-solid fa-arrow-right"></i>
                    </span>
                  </li>
                </ul>
              </div>

              <div className="col-xl-8 col-lg-7 col-sm-6">
                <div className="hl-tech-right-outer">
                  <div
                    className={`row mx-0 g-4 hl-tech-right-row ${
                      techActiveTab === "ai" ? "active" : ""
                    }`}
                  >
                    <div className="col-lg-6">
                      <div className="hl-tech-right-content">
                        <img
                          src={require("../../../image/healthcare/ai-img-one.webp")}
                          alt="Healthcare app development company"
                          loading="lazy"
                        />
                        <span>AI-driven analytics</span>
                      </div>
                    </div>

                    <div className="col-lg-6">
                      <div className="hl-tech-right-content">
                        <img
                          src={require("../../../image/healthcare/ai-img-two.webp")}
                          alt="Healthcare app development company"
                          loading="lazy"
                        />
                        <span>Virtual assistants</span>
                      </div>
                    </div>

                    <div className="col-lg-6">
                      <div className="hl-tech-right-content">
                        <img
                          src={require("../../../image/healthcare/ai-img-three.webp")}
                          alt="Healthcare app development company"
                          loading="lazy"
                        />
                        <span>Predictive diagnostics.</span>
                      </div>
                    </div>
                  </div>

                  <div
                    className={`row mx-0 g-4 hl-tech-right-row ${
                      techActiveTab === "blockchain" ? "active" : ""
                    }`}
                  >
                    <div className="col-lg-6">
                      <div className="hl-tech-right-content fl-cl">
                        <img
                          src={require("../../../image/healthcare/bl.webp")}
                          alt="Healthcare app development company"
                          loading="lazy"
                        />
                        <span>
                          Secure and transparent patient data management
                        </span>
                      </div>
                    </div>
                  </div>

                  <div
                    className={`row mx-0 g-4 hl-tech-right-row ${
                      techActiveTab === "cloud" ? "active" : ""
                    }`}
                  >
                    <div className="col-lg-6">
                      <div className="hl-tech-right-content fl-cl">
                        <img
                          src={require("../../../image/healthcare/cloud.webp")}
                          alt="Healthcare app development company"
                          loading="lazy"
                        />
                        <span>
                          Scalable and accessible cloud-based healthcare
                          solutions.
                        </span>
                      </div>
                    </div>
                  </div>

                  <div
                    className={`row mx-0 g-4 hl-tech-right-row ${
                      techActiveTab === "bigdata" ? "active" : ""
                    }`}
                  >
                    <div className="col-lg-6">
                      <div className="hl-tech-right-content fl-cl">
                        <img
                          src={require("../../../image/healthcare/big.webp")}
                          alt="Healthcare app development company"
                          loading="lazy"
                        />
                        <span>
                          Advanced data insights for better decision-making.
                        </span>
                      </div>
                    </div>
                  </div>

                  <div
                    className={`row mx-0 g-4 hl-tech-right-row ${
                      techActiveTab === "ar" ? "active" : ""
                    }`}
                  >
                    <div className="col-lg-6">
                      <div className="hl-tech-right-content fl-cl">
                        <img
                          src={require("../../../image/healthcare/ar.webp")}
                          alt="Healthcare app development company"
                          loading="lazy"
                        />
                        <span>
                          Immersive training simulations for medical
                          professionals.
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </article>

          {/* benefits */}
          <div className="hl-benefits">
            <article className="primary__landing-content-container">
              <h3 className="hl-subtitle hl-benefits-title">
                Benefits of{" "}
                <span className="hl-span">Hiring Our Healthcare App</span>{" "}
                Development Company
              </h3>
              <p className="hl-subcontent hl-service-content">
                Partnering with a healthcare app development company like ours
                ensures numerous benefits
              </p>

              <div className="row mx-0 hl-key-row g-4">
                <div className="col-lg-4 col-md-6">
                  <div className="hl-benefit-card">
                    <img
                      src={require("../../../image/healthcare/ben-img-one.webp")}
                      alt="Healthcare app development company"
                      loading="lazy"
                    />
                    <h5>Enhanced Patient Care</h5>
                    <p>Improved accessibility to healthcare services.</p>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="hl-benefit-card">
                    <img
                      src={require("../../../image/healthcare/ben-img-two.webp")}
                      alt="Healthcare app development company"
                      loading="lazy"
                    />
                    <h5>Operational Efficiency</h5>
                    <p>
                      Automated workflows and reduced administrative burden.
                    </p>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="hl-benefit-card">
                    <img
                      src={require("../../../image/healthcare/ben-img-three.webp")}
                      alt="Healthcare app development company"
                      loading="lazy"
                    />
                    <h5>Cost Savings</h5>
                    <p>Telemedicine and automation reduce healthcare costs.</p>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="hl-benefit-card">
                    <img
                      src={require("../../../image/healthcare/ben-img-four.webp")}
                      alt="Healthcare app development company"
                      loading="lazy"
                    />
                    <h5>Data Security & Compliance</h5>
                    <p>Full adherence to HIPAA, GDPR, and other regulations.</p>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="hl-benefit-card">
                    <img
                      src={require("../../../image/healthcare/ben-img-five.webp")}
                      alt="Healthcare app development company"
                      loading="lazy"
                    />
                    <h5>Scalability</h5>
                    <p>Solutions that align & grow with your app needs.</p>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="hl-benefit-card">
                    <img
                      src={require("../../../image/healthcare/ben-img-six.webp")}
                      alt="Healthcare app development company"
                      loading="lazy"
                    />
                    <h5>Faster Time to Market</h5>
                    <p>Agile development methodologies for rapid deployment.</p>
                  </div>
                </div>
              </div>
            </article>
          </div>
        </div>

        {/* process */}
        <article className="hl-process primary__landing-content-container hl-mb-100">
          <h3 className="hl-subtitle text-center">
            Our Healthcare App{" "}
            <span className="hl-span">Development Process</span>
          </h3>
          <p className="hl-subcontent text-center">
            We follow a structured approach to ensure high-quality app
            development
          </p>

          <div className="row">
            <div className="col-lg-4"></div>
          </div>

          <div>
            <Swiper
              className="fd-step-swiper hl-process-swiper"
              spaceBetween={30}
              slidesPerView={4}
              modules={[Navigation, A11y]}
              navigation={{
                prevEl: ".hl-process-prev-arr",
                nextEl: ".hl-process-next-arr",
              }}
              breakpoints={{
                320: {
                  slidesPerView: 1,
                  spaceBetween: 10,
                },
                480: {
                  slidesPerView: 1,
                  spaceBetween: 20,
                },
                768: {
                  slidesPerView: 2,
                  spaceBetween: 30,
                },
                1025: {
                  slidesPerView: 3,
                  spaceBetween: 40,
                },
                1200: {
                  slidesPerView: 4,
                  spaceBetween: 30,
                },
              }}
              onSlideChange={handleProcessChange}
              onReachBeginning={() => setIsPrevProcessDisabled(true)}
              onReachEnd={() => setIsNextProcessDisabled(true)}
              onFromEdge={() => {
                setIsPrevProcessDisabled(false);
                setIsNextProcessDisabled(false);
              }}
              speed={500}
            >
              <SwiperSlide>
                <div className="hl-process-card">
                  <span className="hl-process-img-wrap">
                    <img
                      src={require("../../../image/healthcare/process-img-one.webp")}
                      alt="Healthcare app development company"
                      loading="lazy"
                    />
                  </span>
                  <h5>Requirement Analysis</h5>
                  <p>Understanding client needs and goals.</p>

                  <span className="hl-process-num">01</span>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="hl-process-card">
                  <span className="hl-process-img-wrap">
                    <img
                      src={require("../../../image/healthcare/process-img-two.webp")}
                      alt="Healthcare app development company"
                      loading="lazy"
                    />
                  </span>
                  <h5>UI/UX Design</h5>
                  <p>Creating an intuitive and engaging interface.</p>

                  <span className="hl-process-num">02</span>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="hl-process-card">
                  <span className="hl-process-img-wrap">
                    <img
                      src={require("../../../image/healthcare/process-img-three.webp")}
                      alt="Healthcare app development company"
                      loading="lazy"
                    />
                  </span>
                  <h5>Prototyping</h5>
                  <p>Developing a working model for feedback.</p>

                  <span className="hl-process-num">03</span>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="hl-process-card">
                  <span className="hl-process-img-wrap">
                    <img
                      src={require("../../../image/healthcare/process-img-four.webp")}
                      alt="Healthcare app development company"
                      loading="lazy"
                    />
                  </span>
                  <h5>Development</h5>
                  <p>Building secure and scalable applications.</p>

                  <span className="hl-process-num">04</span>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="hl-process-card">
                  <span className="hl-process-img-wrap">
                    <img
                      src={require("../../../image/healthcare/process-img-five.webp")}
                      alt="Healthcare app development company"
                      loading="lazy"
                    />
                  </span>
                  <h5>Testing</h5>
                  <p>Rigorous testing for performance and security.</p>

                  <span className="hl-process-num">05</span>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="hl-process-card">
                  <span className="hl-process-img-wrap">
                    <img
                      src={require("../../../image/healthcare/process-img-six.webp")}
                      alt="Healthcare app development company"
                      loading="lazy"
                    />
                  </span>
                  <h5>Deployment</h5>
                  <p> Launching the app on desired platforms.</p>

                  <span className="hl-process-num">06</span>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="hl-process-card">
                  <span className="hl-process-img-wrap">
                    <img
                      src={require("../../../image/healthcare/process-img-seven.webp")}
                      alt="Healthcare app development company"
                      loading="lazy"
                    />
                  </span>
                  <h5>Maintenance & Support</h5>
                  <p>Continuous updates and improvements.</p>

                  <span className="hl-process-num">07</span>
                </div>
              </SwiperSlide>
            </Swiper>

            <div className="fd-step-btn-wrap">
              <button
                className={`hl-process-prev-arr ${
                  isPrevProcessDisabled ? "disabled" : ""
                }`}
                style={{
                  color: isPrevProcessDisabled ? "#ffffff" : "#ffffff",
                  cursor: isPrevProcessDisabled ? "not-allowed" : "pointer",
                  background: isPrevProcessDisabled ? "#B7B7B8" : "#0E0E10",
                }}
              >
                <i className="fa-solid fa-chevron-left"></i>
              </button>
              <button
                className={`hl-process-next-arr ${
                  isNextProcessDisabled ? "disabled" : ""
                }`}
                style={{
                  color: isNextProcessDisabled ? "#ffffff" : "#ffffff",
                  cursor: isNextProcessDisabled ? "not-allowed" : "pointer",
                  background: isNextProcessDisabled ? "#B7B7B8" : "#0E0E10",
                }}
              >
                <i className="fa-solid fa-chevron-right"></i>
              </button>
            </div>
          </div>
        </article>

        {/* industries */}
        <article className="hl-industries primary__landing__container hl-mb-100">
          <h3 className="hl-subtitle text-center">
            {" "}
            <span className="hl-span">Industries </span> We Serve
          </h3>
          <p className="hl-subcontent hl-ind-content">
            Our healthcare app development company caters to various segments
            within the healthcare ecosystem
          </p>

          <div className="hl-marquee-wrap-outer">
            <div
              // onMouseEnter={() => setIsHovered(true)}
              // onMouseLeave={() => setIsHovered(false)}
              className="hl-marquee-wrap"
            >
              <Marquee
                className="marquee-outer"
                velocity={velocity}
                direction="rtl"
                resetAfterTries={200}
                // velocity={isHovered ? 0 : velocity}
              >
                <div className="hl-ind-card ">
                  <img
                    src={require("../../../image/healthcare/ind-img-one.webp")}
                    alt="Healthcare app development company"
                    loading="lazy"
                  />
                  <h5>Hospitals and Clinics</h5>
                </div>
                <div className="hl-ind-card ">
                  <img
                    src={require("../../../image/healthcare/ind-img-two.webp")}
                    alt="Healthcare app development company"
                    loading="lazy"
                  />
                  <h5>Telemedicine Providers</h5>
                </div>
                <div className="hl-ind-card ">
                  <img
                    src={require("../../../image/healthcare/ind-img-three.webp")}
                    alt="Healthcare app development company"
                    loading="lazy"
                  />
                  <h5>Pharmacies and Drug Stores</h5>
                </div>
                <div className="hl-ind-card ">
                  <img
                    src={require("../../../image/healthcare/ind-img-four.webp")}
                    alt="Healthcare app development company"
                    loading="lazy"
                  />
                  <h5>Health Insurance Companies</h5>
                </div>
                <div className="hl-ind-card ">
                  <img
                    src={require("../../../image/healthcare/ind-img-five.webp")}
                    alt="Healthcare app development company"
                    loading="lazy"
                  />
                  <h5>Medical Research Institutions</h5>
                </div>
              </Marquee>

              <div className="hl-marquee-two">
                <Marquee
                  velocity={velocity}
                  direction="ltr"
                  resetAfterTries={200}
                >
                  <div className="hl-ind-card rev">
                    <img
                      src={require("../../../image/healthcare/ind-img-four.webp")}
                      alt="Healthcare app development company"
                      loading="lazy"
                    />
                    <h5>Health Insurance Companies</h5>
                  </div>

                  <div className="hl-ind-card rev">
                    <img
                      src={require("../../../image/healthcare/ind-img-two.webp")}
                      alt="Healthcare app development company"
                      loading="lazy"
                    />
                    <h5>Telemedicine Providers</h5>
                  </div>

                  <div className="hl-ind-card rev">
                    <img
                      src={require("../../../image/healthcare/ind-img-five.webp")}
                      alt="Healthcare app development company"
                      loading="lazy"
                    />
                    <h5>Medical Research Institutions</h5>
                  </div>

                  <div className="hl-ind-card rev">
                    <img
                      src={require("../../../image/healthcare/ind-img-one.webp")}
                      alt="Healthcare app development company"
                      loading="lazy"
                    />
                    <h5>Hospitals and Clinics</h5>
                  </div>

                  <div className="hl-ind-card rev">
                    <img
                      src={require("../../../image/healthcare/ind-img-three.webp")}
                      alt="Healthcare app development company"
                      loading="lazy"
                    />
                    <h5>Pharmacies and Drug Stores</h5>
                  </div>
                </Marquee>
              </div>
            </div>
          </div>
        </article>

        {/* why choose */}
        <article className="hl-choose primary__landing-content-container">
          <div className="text-center">
            <img
              src={require("../../../image/healthcare/why-choose.webp")}
              alt="Healthcare app development company"
              loading="lazy"
            />
            <h3 className="hl-subtitle hl-choose-title">
              Why Choose Our <span className="hl-span">Healthcare App</span>{" "}
              Development Company?
            </h3>
            <p className="hl-subcontent hl-choose-content">
              Choosing the right healthcare app development company is crucial
              for delivering secure, compliant, and user-friendly applications.
              Here’s why our company stands out
            </p>
          </div>

          <div>
            <Swiper
              className="fd-step-swiper"
              spaceBetween={30}
              slidesPerView={3}
              modules={[Navigation, A11y]}
              navigation={{
                prevEl: ".hl-choose-prev-arr",
                nextEl: ".hl-choose-next-arr",
              }}
              breakpoints={{
                320: {
                  slidesPerView: 1,
                  spaceBetween: 10,
                },
                480: {
                  slidesPerView: 1,
                  spaceBetween: 20,
                },
                768: {
                  slidesPerView: 2,
                  spaceBetween: 30,
                },
                1025: {
                  slidesPerView: 3,
                  spaceBetween: 40,
                },
                1200: {
                  slidesPerView: 3,
                  spaceBetween: 30,
                },
              }}
              onSlideChange={handleChooseChange}
              onReachBeginning={() => setIsPrevChooseDisabled(true)}
              onReachEnd={() => setIsNextChooseDisabled(true)}
              onFromEdge={() => {
                setIsPrevChooseDisabled(false);
                setIsNextChooseDisabled(false);
              }}
              speed={500}
            >
              <SwiperSlide>
                <div className="hl-choose-card">
                  <div className="hl-choose-top">
                    <img
                      src={require("../../../image/healthcare/choose-img-one.webp")}
                      alt="Healthcare app development company"
                      loading="lazy"
                    />
                    <h5>Expertise in Healthcare Domain</h5>
                  </div>
                  <div className="hl-choose-main">
                    <p>
                      We have a team of developers, UI/UX designers, and
                      healthcare professionals who understand industry
                      requirements.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="hl-choose-card">
                  <div className="hl-choose-top">
                    <img
                      src={require("../../../image/healthcare/choose-img-two.webp")}
                      alt="Healthcare app development company"
                      loading="lazy"
                    />
                    <h5>HIPAA & GDPR Compliance</h5>
                  </div>
                  <div className="hl-choose-main">
                    <p>
                      Our apps comply with global healthcare regulations to
                      ensure data privacy and security.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="hl-choose-card">
                  <div className="hl-choose-top">
                    <img
                      src={require("../../../image/healthcare/choose-img-three.webp")}
                      alt="Healthcare app development company"
                      loading="lazy"
                    />
                    <h5>Customized Solutions</h5>
                  </div>
                  <div className="hl-choose-main">
                    <p>
                      We provide tailor-made solutions to meet the specific
                      needs of healthcare providers.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="hl-choose-card">
                  <div className="hl-choose-top">
                    <img
                      src={require("../../../image/healthcare/choose-img-four.webp")}
                      alt="Healthcare app development company"
                      loading="lazy"
                    />
                    <h5>Advanced Technologies</h5>
                  </div>
                  <div className="hl-choose-main">
                    <p>
                      Our expertise includes AI-driven diagnostics, IoT-enabled
                      devices, blockchain-based health records, and cloud
                      computing.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="hl-choose-card">
                  <div className="hl-choose-top">
                    <img
                      src={require("../../../image/healthcare/choose-img-five.webp")}
                      alt="Healthcare app development company"
                      loading="lazy"
                    />
                    <h5>End-to-End Development</h5>
                  </div>
                  <div className="hl-choose-main">
                    <p>
                      From ideation to deployment, we handle everything,
                      including UI/UX design, development, testing, and
                      maintenance.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="hl-choose-card">
                  <div className="hl-choose-top">
                    <img
                      src={require("../../../image/healthcare/choose-img-six.webp")}
                      alt="Healthcare app development company"
                      loading="lazy"
                    />
                    <h5>Interoperability</h5>
                  </div>
                  <div className="hl-choose-main">
                    <p>
                      Our apps integrate seamlessly with existing hospital
                      management systems (HMS) and electronic health records
                      (EHR).
                    </p>
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>

            <div className="fd-step-btn-wrap">
              <button
                className={`hl-choose-prev-arr ${
                  isPrevChooseDisabled ? "disabled" : ""
                }`}
                style={{
                  color: isPrevChooseDisabled ? "#ffffff" : "#ffffff",
                  cursor: isPrevChooseDisabled ? "not-allowed" : "pointer",
                  background: isPrevChooseDisabled ? "#B7B7B8" : "#0E0E10",
                }}
              >
                <i className="fa-solid fa-chevron-left"></i>
              </button>
              <button
                className={`hl-choose-next-arr ${
                  isNextChooseDisabled ? "disabled" : ""
                }`}
                style={{
                  color: isNextChooseDisabled ? "#ffffff" : "#ffffff",
                  cursor: isNextChooseDisabled ? "not-allowed" : "pointer",
                  background: isNextChooseDisabled ? "#B7B7B8" : "#0E0E10",
                }}
              >
                <i className="fa-solid fa-chevron-right"></i>
              </button>
            </div>
          </div>
        </article>

        {/* Take Away*/}
        <div className="rs-mt-100 custom-get-in-touch ply-ta">
          <div className="primary__landing-content-container ">
            <h5 className="custom-get-title ph-take-title dt-get-title">
              Take Away
            </h5>
            <p className="custom-get-content dt-get-content">
              The healthcare industry is undergoing a digital revolution, and
              having a reliable healthcare app development company is crucial
              for success. We specialize in creating cutting-edge, secure, and
              scalable healthcare applications that meet the highest standards
              of compliance and innovation. Whether you need a telemedicine app,
              EHR solution, AI-powered diagnostics, our healthcare app
              development company is here to turn your vision into reality. Get
              in touch with us today to discuss your project and take the next
              step toward digital healthcare transformation.
            </p>

            <div className="d-flex align-items-center justify-content-center">
              <button
                data-toggle="modal"
                data-target="#myModal"
                className="fiu-need-left-btn mt-4 re-hero-btn"
              >
                <div className="re-btn-txt">Get Free Consultation</div>
                <span className="mx-2 right-arr">
                  <i className="fa-solid fa-arrow-right"></i>
                </span>
              </button>
            </div>
          </div>
        </div>
      </main>

      {/* faq */}
      <article className="primary__landing-content-container">
        <div className="landing-faq-wrapper">
          <div className="row">
            <div className="col-lg-6">
              <h6 className="landing-faq-left-title">
                Frequently Asked <span className="faq-span">Questions.</span>{" "}
                {""}
              </h6>
            </div>
            <div className="col-lg-6">
              <div>
                <div className="container">
                  <div className="accordion" id="faq">
                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead1">
                        <button
                          className="landing-faq-title collapsed"
                          type="button"
                          data-toggle="collapse"
                          data-target="#faq1"
                          aria-expanded="true"
                          aria-controls="faq1"
                        >
                          Why should I invest in a healthcare app?
                        </button>
                      </div>

                      <div
                        id="faq1"
                        className="collapse"
                        aria-labelledby="faqhead1"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          Investing in a healthcare app improves patient
                          engagement, boosts operational efficiency, and
                          provides better access to medical services. It can
                          also help healthcare providers reduce administrative
                          tasks and enhance service delivery.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead2">
                        <div
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq2"
                          aria-expanded="true"
                          aria-controls="faq2"
                        >
                          What are the key features of a healthcare app?
                        </div>
                      </div>

                      <div
                        id="faq2"
                        className="collapse"
                        aria-labelledby="faqhead2"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          Key features include appointment scheduling,
                          telemedicine, medication management, health tracking,
                          patient records management, and secure payment
                          gateways. These features improve user experience and
                          healthcare management.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead3">
                        <div
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq3"
                          aria-expanded="true"
                          aria-controls="faq3"
                        >
                          How do I ensure my healthcare app is secure?
                        </div>
                      </div>

                      <div
                        id="faq3"
                        className="collapse"
                        aria-labelledby="faqhead3"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          To ensure security, your app should comply with
                          regulations like HIPAA, use encryption for data
                          storage, and implement secure authentication methods.
                          Regular security audits and updates are crucial to
                          maintaining privacy.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead4">
                        <div
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq4"
                          aria-expanded="true"
                          aria-controls="faq4"
                        >
                          How do I choose the right healthcare app development
                          company?
                        </div>
                      </div>

                      <div
                        id="faq4"
                        className="collapse"
                        aria-labelledby="faqhead4"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          Choose a company with experience in healthcare,
                          expertise in both iOS and Android platforms, and a
                          strong focus on security and regulatory compliance.
                          Look for a company with a proven track record of
                          successful healthcare app projects.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </article>

      <ServiceFooter />
    </>
  );
};

export default Healthcare;
